// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"dcd40fa2","97":"7647f38a","318":"ed1c3044","546":"16556c49","837":"dc02e782","980":"81766950"}[chunkId] + ".chunk.js";
};